"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Shape_1 = require("./Shape");
/**
 * 可选中图形
 */
var SelectAbleShape = /** @class */ (function (_super) {
    __extends(SelectAbleShape, _super);
    function SelectAbleShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectAbleShape.prototype.onMouseDown = function (e) {
        var _this = this;
        if (!this.isSelected()) {
            this.select();
            this.drawState = { strokeStyle: 'red' };
            // clone 到一个新的画布上
            var newViewPort_1 = e.viewport.clone();
            // 处理取消问题
            newViewPort_1.engine.ctx.canvas.addEventListener('mousedown', function (ev) {
                var _a = e.viewport.engine.ctx.canvas, offsetTop = _a.offsetTop, offsetLeft = _a.offsetLeft;
                var _b = __read([ev.offsetX - offsetLeft, ev.offsetY - offsetTop], 2), x = _b[0], y = _b[1];
                var vev = newViewPort_1.transformEvent('move', [x, y]);
                var result = newViewPort_1.engine.hitTest(vev.p);
                // 取消选中
                if (result.length === 0) {
                    _this.drawState = {
                        strokeStyle: '#000',
                        fillStyle: '#000',
                    };
                    // 把自身再次移动回原有画布
                    e.viewport.engine.add(_this);
                    e.viewport.engine.render(true);
                    newViewPort_1.engine.ctx.canvas.remove();
                    _this.unSelect();
                }
            });
            // 将自身从旧的画布中移除
            this.remove();
            // 清除在原有画布上的选中内容
            e.viewport.engine.clearAll();
            e.viewport.engine.render();
            // 把自己添加到新画布中
            newViewPort_1.engine.add(this);
            // 触发选中函数
            this.onSelected(newViewPort_1, e);
            // 渲染新画布
            newViewPort_1.engine.render();
            // 将新画布追加到编辑器中
            e.viewport.appendViewPort(newViewPort_1);
            // 重新渲染底层画布
            e.viewport.engine.render(true);
        }
        return false;
    };
    /**
     * 取消选中
     */
    SelectAbleShape.prototype.unSelect = function () {
        this.drawState = {
            strokeStyle: '#000',
        };
        this.onUnSelected();
        _super.prototype.unSelect.call(this);
    };
    return SelectAbleShape;
}(Shape_1.Shape));
exports.SelectAbleShape = SelectAbleShape;
//# sourceMappingURL=SelectAbleShape.js.map